import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import VenueDetailPage from './VenueDetailPage';
import DistrictVenuePage from './DistrictVenuePage';
import VenuesPage from './VenuesPage';
import NotFoundPage from './NotFoundPage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SlugRouter = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [pageType, setPageType] = useState(null); // null = checking, 'venue', 'city', 'notfound'
  
  useEffect(() => {
    const checkSlugType = async () => {
      // City pages end with -davet-evleri (plural) - no API check needed
      if (slug && slug.endsWith('-davet-evleri')) {
        setPageType('city');
        return;
      }
      
      // For slugs ending with -davet-evi, check if it's a venue first
      if (slug && slug.endsWith('-davet-evi')) {
        try {
          // Try to fetch as venue
          const response = await axios.get(`${BACKEND_URL}/api/venue/${slug}`);
          if (response.data && response.data.id) {
            // It's a venue!
            setPageType('venue');
            return;
          }
        } catch (error) {
          // Not a venue, might be old district format
          // console.log('Slug is not a venue, checking district format...');
        }
        
        // Old district format: /bursa-gemlik-davet-evi -> /bursa/gemlik
        const slugPart = slug.slice(0, -10); // Remove '-davet-evi'
        const parts = slugPart.split('-');
        
        if (parts.length >= 2) {
          const citySlug = parts[0];
          const districtSlug = parts.slice(1).join('-');
          navigate(`/${citySlug}/${districtSlug}`, { replace: true });
          return;
        }
        
        setPageType('notfound');
        return;
      }
      
      // Check if it's a valid city slug (single word like /bursa, /istanbul)
      if (slug && !slug.includes('-')) {
        try {
          const response = await axios.get(`${BACKEND_URL}/api/cities`);
          const cities = response.data || [];
          const cityExists = cities.some(city => 
            city.slug?.toLowerCase() === slug.toLowerCase() ||
            city.name?.toLowerCase() === slug.toLowerCase()
          );
          if (cityExists) {
            setPageType('city');
            return;
          }
        } catch (error) {
          // console.log('Error checking city:', error);
        }
      }
      
      // Try to fetch as venue
      try {
        const response = await axios.get(`${BACKEND_URL}/api/venue/${slug}`);
        if (response.data && response.data.id) {
          setPageType('venue');
          return;
        }
      } catch (error) {
        // Not a venue
        // console.log('Slug is not a venue');
      }
      
      // Nothing found - 404
      setPageType('notfound');
    };
    
    checkSlugType();
  }, [slug, navigate]);
  
  // Still checking
  if (pageType === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-pink-600"></div>
      </div>
    );
  }
  
  // City pages
  if (pageType === 'city') {
    return <VenuesPage />;
  }
  
  // Venue page
  if (pageType === 'venue') {
    return <VenueDetailPage />;
  }
  
  // 404 Not Found
  return <NotFoundPage />;
};

export default SlugRouter;
